import { useEffect } from 'react';

import useLoggedInUserData from '@/hooks/useUserData/useLoggedInUserData';
import useNewRequestLogic from '@/pages/NewRequest/useNewRequestLogic';

interface UseNewRequestModalLogicProps {
    userId: string;
    userFullName: string;
    userEmail: string;
    startDate: Date;
    endDate: Date;
    onSuccess: () => void;
}

export const useNewRequestModalLogic = ({
    userId,
    userFullName,
    userEmail,
    startDate,
    endDate,
    onSuccess,
}: UseNewRequestModalLogicProps) => {
    const logic = useNewRequestLogic();
    const { newRequestFormik, isCreatedSuccess } = logic;
    const { isLead, credentialId, userFullName: currentUserFullName, email: currentUserEmail } = useLoggedInUserData();

    useEffect(() => {
        const targetUserId = isLead ? userId : credentialId;
        const targetUserFullName = isLead ? userFullName : currentUserFullName;
        const targetUserEmail = isLead ? userEmail : currentUserEmail;

        if (targetUserId && targetUserFullName) {
            newRequestFormik.setFieldValue('selectedUser', {
                userId: targetUserId,
                label: targetUserFullName,
                userMail: targetUserEmail || '',
            });

            newRequestFormik.setFieldValue('dateRange', {
                startDate,
                endDate,
            });
        }
    }, [
        userId,
        userFullName,
        userEmail,
        startDate,
        endDate,
        isLead,
        credentialId,
        currentUserFullName,
        currentUserEmail,
    ]);

    useEffect(() => {
        if (isCreatedSuccess) {
            onSuccess();
        }
    }, [isCreatedSuccess, onSuccess]);

    return logic;
};
